<script setup lang="ts">
import LGShopItem from "~/components/partials/LGShopItem.vue";
import LGShopNewsletter from "~/components/partials/LGShopNewsletter.vue";
import { useProductsStore } from '~~/stores/products'

const route = useRoute()
const store = useProductsStore()

const page = computed(() => Number(route.query.page ?? 1))
const perPage = 12
const locale = (useI18n?.() as any)?.locale?.value ?? 'sl'

await store.fetchList({ page: page.value, per_page: perPage, locale })

watch([page], async () => {
    await store.fetchList({ page: page.value, per_page: perPage, locale })
})
</script>

<template>
    <section class="py-12 sm:py-24 relative overflow-x-clip">
        <NuxtImg src="/images/shop/shop-illustration-1.svg" alt="Pin" class="hidden lg:block w-[47px] absolute bottom-[200px] right-[10%]" />
        <NuxtImg src="/images/shop/shop-illustration-2.svg" alt="Pin" class="w-[109px] lg:w-[227px] absolute -top-4 lg:top-10 -left-[30px] lg:left-0" />
        <NuxtImg src="/images/shop/shop-illustration-3.svg" alt="Map" class="hidden lg:block lg:w-[134px] absolute lg:-bottom-16 lg:right-0" />
        <NuxtImg src="/images/shop/shop-cloud.svg" alt="Cloud" class="w-[49px] lg:w-[176px] absolute bottom-[30%] -left-4" />
        <NuxtImg src="/images/shop/shop-cloud.svg" alt="Cloud" class="hidden lg:block w-[109px] absolute top-[40%] right-[100px]" />
        <NuxtImg src="/images/shop/shop-cloud.svg" alt="Cloud" class="w-[73px] lg:w-[176px] absolute top-[50%] -right-4" />
        <NuxtImg src="/images/shop/shop-bg-top.svg" alt="Top background" class="w-full h-auto -mb-[1px]" />
        <div class="bg-[#EEEEFA] py-12">
            <UContainer class="lg:max-w-[1000px] flex flex-col gap-12">
                <div class="flex flex-col gap-12 z-1">
                    <LGShopItem v-for="p in store.items" :key="p.product_id" :product="p" />
                </div>
                <LGShopNewsletter/>
            </UContainer>
        </div>
        <NuxtImg src="/images/shop/shop-bg-bottom.svg" alt="Bottom background" class="w-full h-auto -mt-[1px]" />
    </section>
</template>

<style scoped>

</style>
